import React from 'react';
import { twMerge } from 'tailwind-merge';

const STATUS_COPY = {
  required: 'REQUIRED',
  optional: 'OPTIONAL',
};

const STATUS_STYLE = {
  required: 'bg-purple-purple01 text-text-accent',
  optional: 'bg-grayscale-gray01 text-grayscale-gray04',
};

function StatusPill({ status = 'required', className }) {
  const normalizedStatus = status === 'optional' ? 'optional' : 'required';

  return (
    <span
      className={twMerge(
        'inline-flex h-5 shrink-0 items-center justify-center rounded-full px-2 typo-b11Strong',
        STATUS_STYLE[normalizedStatus],
        className
      )}
    >
      {STATUS_COPY[normalizedStatus]}
    </span>
  );
}

export default StatusPill;
